import { render, staticRenderFns } from "./AppPaidServicePackageRow.vue?vue&type=template&id=1831ed92"
import script from "./AppPaidServicePackageRow.vue?vue&type=script&lang=js"
export * from "./AppPaidServicePackageRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports